import CitySalaryPageTemplate from "@/components/CitySalaryPageTemplate";
import { CITY_SALARY_DATA } from "@/data/citySalaryData";

export default function SoftwareEngineerBangalore() {
  return <CitySalaryPageTemplate data={CITY_SALARY_DATA["software-engineer-bangalore"]} />;
}
